package io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.icons

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.Icons

public val Icons.CategoryW500Rounded: ImageVector
    get() {
        if (_categoryW500Rounded != null) {
            return _categoryW500Rounded!!
        }
        _categoryW500Rounded = Builder(name = "CategoryW500Rounded", defaultWidth = 24.0.dp, defaultHeight = 24.0.dp, viewportWidth = 960.0f, viewportHeight = 960.0f).apply {
            path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f, pathFillType = NonZero) {
                moveToRelative(287.91f, 379.48f)
                lineToRelative(153.31f, -250.41f)
                quadToRelative(6.71f, -11.2f, 17.02f, -16.42f)
                quadToRelative(10.3f, -5.22f, 21.75f, -5.22f)
                quadToRelative(11.44f, 0.0f, 21.76f, 5.22f)
                quadToRelative(10.32f, 5.22f, 17.03f, 16.42f)
                lineToRelative(153.31f, 250.41f)
                quadToRelative(6.95f, 11.34f, 6.95f, 23.82f)
                reflectiveQuadToRelative(-5.71f, 22.68f)
                quadToRelative(-5.72f, 10.19f, -15.94f, 16.53f)
                quadToRelative(-10.22f, 6.34f, -23.85f, 6.34f)
                lineTo(326.46f, 448.85f)
                quadToRelative(-13.63f, 0.0f, -23.85f, -6.34f)
                reflectiveQuadToRelative(-15.94f, -16.52f)
                quadToRelative(-5.71f, -10.18f, -5.71f, -22.63f)
                reflectiveQuadToRelative(6.95f, -23.88f)
                close()
                moveTo(706.65f, 894.59f)
                quadToRelative(-78.3f, 0.0f, -133.19f, -54.82f)
                quadToRelative(-54.89f, -54.81f, -54.89f, -133.12f)
                quadToRelative(0.0f, -78.3f, 54.86f, -133.19f)
                reflectiveQuadToRelative(133.24f, -54.89f)
                quadToRelative(78.37f, 0.0f, 133.15f, 54.86f)
                quadToRelative(54.77f, 54.86f, 54.77f, 133.24f)
                quadToRelative(0.0f, 78.37f, -54.82f, 133.15f)
                quadToRelative(-54.81f, 54.77f, -133.12f, 54.77f)
                close()
                moveTo(101.59f, 829.09f)
                verticalLineToRelative(-245.02f)
                quadToRelative(0.0f, -19.16f, 13.17f, -32.33f)
                quadToRelative(13.17f, -13.17f, 32.33f, -13.17f)
                horizontalLineToRelative(245.26f)
                quadToRelative(19.15f, 0.0f, 32.32f, 13.17f)
                quadToRelative(13.18f, 13.17f, 13.18f, 32.33f)
                verticalLineToRelative(245.02f)
                quadToRelative(0.0f, 19.15f, -13.18f, 32.32f)
                quadToRelative(-13.17f, 13.18f, -32.32f, 13.18f)
                lineTo(147.09f, 874.59f)
                quadToRelative(-19.16f, 0.0f, -32.33f, -13.18f)
                quadToRelative(-13.17f, -13.17f, -13.17f, -32.32f)
                close()
                moveTo(706.7f, 803.59f)
                quadToRelative(40.56f, 0.0f, 68.72f, -28.17f)
                quadToRelative(28.17f, -28.16f, 28.17f, -68.72f)
                quadToRelative(0.0f, -40.57f, -28.17f, -68.85f)
                quadToRelative(-28.16f, -28.28f, -68.72f, -28.28f)
                quadToRelative(-40.57f, 0.0f, -68.85f, 28.28f)
                quadToRelative(-28.28f, 28.28f, -28.28f, 68.85f)
                quadToRelative(0.0f, 40.56f, 28.28f, 68.72f)
                quadToRelative(28.28f, 28.17f, 68.85f, 28.17f)
                close()
                moveTo(192.59f, 783.59f)
                horizontalLineToRelative(154.26f)
                verticalLineToRelative(-154.02f)
                lineTo(192.59f, 629.57f)
                verticalLineToRelative(154.02f)
                close()
                moveTo(407.5f, 357.85f)
                horizontalLineToRelative(145.0f)
                lineTo(480.0f, 240.22f)
                lineToRelative(-72.5f, 117.63f)
                close()
                moveTo(480.0f, 357.85f)
                close()
                moveTo(346.85f, 629.57f)
                close()
                moveTo(706.7f, 706.7f)
                close()
            }
        }
        .build()
        return _categoryW500Rounded!!
    }

private var _categoryW500Rounded: ImageVector? = null
